// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.form_TU2Lr {
  width: 600px;
  min-height : 410px;
  max-height : 410px;
  max-width: 100vw;
  padding: 24px !important;
}

.formBreakdown_LAqXs {
  width: 600px;
  max-width: 100vw;
  min-height : 410px;
  max-height : 410px;
  padding: 16px;
}

.fixed_gFXD7 {
  width : 100%;
  position : relative;
  height : 100%;
}

.image_AWKFg {
  width : 140px;
  height : 140px;
  margin-top : 72px;
}

.bold_bvelL {
  font-weight: 600;
}`, "",{"version":3,"sources":["webpack://./../../node_modules/@leverege/molten/lib/imagine/forms/BulkUpdateForm.css"],"names":[],"mappings":"AAAA;EACE,YAAY;EACZ,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;EAChB,wBAAwB;AAC1B;;AAEA;EACE,YAAY;EACZ,gBAAgB;EAChB,kBAAkB;EAClB,kBAAkB;EAClB,aAAa;AACf;;AAEA;EACE,YAAY;EACZ,mBAAmB;EACnB,aAAa;AACf;;AAEA;EACE,aAAa;EACb,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;AAClB","sourcesContent":[".form {\n  width: 600px;\n  min-height : 410px;\n  max-height : 410px;\n  max-width: 100vw;\n  padding: 24px !important;\n}\n\n.formBreakdown {\n  width: 600px;\n  max-width: 100vw;\n  min-height : 410px;\n  max-height : 410px;\n  padding: 16px;\n}\n\n.fixed {\n  width : 100%;\n  position : relative;\n  height : 100%;\n}\n\n.image {\n  width : 140px;\n  height : 140px;\n  margin-top : 72px;\n}\n\n.bold {\n  font-weight: 600;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"form": `form_TU2Lr`,
	"formBreakdown": `formBreakdown_LAqXs`,
	"fixed": `fixed_gFXD7`,
	"image": `image_AWKFg`,
	"bold": `bold_bvelL`
};
export default ___CSS_LOADER_EXPORT___;
